import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // This will still work even though App.jsx
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();